module.exports = __webpack_public_path__ + "img/Frame-68.5e64fe28.svg";